.invoice {
  padding: 1rem;
  composes: border from '../../routes/overview/Overview.css';
}

.header {
  display: flex;
  justify-content: space-between;
}

.itemContainer {
  display: flex;
  width: 90%;
  gap: 1rem;
  justify-content: space-between;
}

.attributeItem {
  display: flex;
  gap: 0.5rem;
}

@media (max-width: 768px) {
  .itemContainer {
    width: 100%;
  }
}
